import ReactGA from 'react-ga4';

import { type HyperdxBaseConfig, setZettaClient } from '@zep/core-logger';
import { ZettaClient } from '@zep/logger/zetta';

export { sentryLoggerAdapter as Sentry } from '@zep/sentry';

export const zettaClient = new ZettaClient();
setZettaClient(zettaClient);

export const ga4Dispatch = (event: string, params: Record<string, unknown>) =>
  ReactGA.event(event, params);

const serverBaseUrl = process.env.NEXT_PUBLIC_SERVER_BASEURL;

export const hyperdxLoggerConfig: HyperdxBaseConfig | undefined = serverBaseUrl
  ? {
      service: 'quiz-app',
      consoleCapture: false,
      debug: false,
      tracePropagationTargets: [new RegExp(serverBaseUrl, 'i')],
      disableReplay: true,
      // ignoreUrls는 @zep/logger의 내부(zep) 도메인 allowlist 기본값을 사용한다.
      // (이전의 serverBaseUrl 기반 ignoreUrls는 init에 전달되지 않아 동작하지 않았다)
    }
  : undefined;

if (typeof window !== 'undefined') {
  zettaClient.initialize();

  ReactGA.initialize([
    { trackingId: `${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID}` },
  ]);
  ReactGA.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ADS_TRACKING_ID);

  if (!serverBaseUrl) {
    console.error(
      '[logger.config] NEXT_PUBLIC_SERVER_BASEURL is not set — HyperDX init skipped',
    );
  }
}
